import React from 'react';
import StandingChip from './StandingChip';
import { OverviewProject, STANDARDS, StandardId } from './types';

interface Props {
  project: OverviewProject;
  planningQuarter: string | null;
  onOpen: (standard: StandardId, projectKey: string) => void;
}

// One project: the four standards for the month, each opening its page for this project, and one
// plain sentence about what moved.
export default function ProjectCard({ project, planningQuarter, onOpen }: Props) {
  return (
    <article className="rounded-2xl bg-white p-4 shadow-sm ring-1 ring-gray-200/70 contrast-more:ring-gray-400" aria-label={project.project_name ?? project.project_key}>
      <header className="min-w-0">
        <h3 className="truncate text-xs font-semibold uppercase tracking-wider text-gray-500">{project.project_key}</h3>
        <p className="truncate text-sm text-gray-700">{project.project_name ?? ''}</p>
      </header>
      <div className="mt-3 grid grid-cols-2 gap-2">
        {STANDARDS.map((s) => (
          <StandingChip
            key={s.id}
            standard={s.id}
            standing={project[s.id]}
            planningQuarter={planningQuarter}
            onPress={() => onOpen(s.id, project.project_key)}
            pressLabel={`Open ${s.label} for ${project.project_key}`}
          />
        ))}
      </div>
      <p className="mt-3 text-sm leading-snug text-gray-700">{project.sentence}</p>
    </article>
  );
}
